<template>
  <div ref="sidebar" class="sidebar sidebar-container">
    <div class="menu-items">
      <!--      收藏菜单-->
      <template v-if="favoriteMenus.length > 0">
        <sidebar-item :key="999" :item="newFavoriteMenus()"></sidebar-item>
      </template>
      <!--      系统菜单-->
      <sidebar-item v-for="item in routes" :key="item.id" :item="item"></sidebar-item>
    </div>
  </div>
</template>

<script>
import SidebarItem from "./SidebarItem/index.vue"
import { mapState } from "vuex"

export default {
  components: { SidebarItem },
  data() {
    return {
      activeGroups: [], // 存储展开的组
      menuData: [
        {
          createTime: "2024-07-27 14:08:54",
          updateTime: "2024-07-27 14:08:54",
          creator: "太阳",
          updateBy: "",
          isDel: false,
          id: 155,
          parentId: 0,
          name: "营销中台",
          abbrName: "营销",
          icon: "https://test-static.tfeimall.com/src/menu/menuIcon_1fbdd90f-9bdb-4fb5-8c3e-200927fb9b4a_1722060514262.png",
          url: "",
          perms: "",
          type: 1,
          orderNum: 0,
          isShow: true,
          isSepaLine: false,
          list: [
            {
              createTime: "2024-07-27 14:09:44",
              updateTime: "2024-07-27 14:09:44",
              creator: "太阳",
              updateBy: "",
              isDel: false,
              id: 156,
              parentId: 155,
              name: "WCT",
              abbrName: "",
              icon: "",
              url: "/userData",
              perms: "",
              type: 1,
              orderNum: 0,
              isShow: true,
              isSepaLine: false,
              list: [
                {
                  createTime: "2024-07-27 14:10:06",
                  updateTime: "2024-07-27 14:10:06",
                  creator: "太阳",
                  updateBy: "",
                  isDel: false,
                  id: 157,
                  parentId: 156,
                  name: "微营销会话",
                  abbrName: "",
                  icon: "",
                  url: "/userData/wxChat",
                  perms: "",
                  type: 1,
                  orderNum: 0,
                  isShow: true,
                  isSepaLine: false,
                  isAdmin: 0
                },
                {
                  createTime: "2024-07-27 14:10:31",
                  updateTime: "2024-07-27 14:10:31",
                  creator: "太阳",
                  updateBy: "",
                  isDel: false,
                  id: 158,
                  parentId: 156,
                  name: "数据看板",
                  abbrName: "",
                  icon: "",
                  url: "/userData/marketPage",
                  perms: "",
                  type: 1,
                  orderNum: 0,
                  isShow: true,
                  isSepaLine: false,
                  isAdmin: 0
                },
                {
                  createTime: "2024-07-27 14:10:48",
                  updateTime: "2024-07-27 14:10:48",
                  creator: "太阳",
                  updateBy: "",
                  isDel: false,
                  id: 159,
                  parentId: 156,
                  name: "历史消息",
                  abbrName: "",
                  icon: "",
                  url: "/userData/historyMsg",
                  perms: "",
                  type: 1,
                  orderNum: 0,
                  isShow: true,
                  isSepaLine: false,
                  isAdmin: 0
                },
                {
                  createTime: "2024-07-27 14:11:16",
                  updateTime: "2024-07-27 14:11:16",
                  creator: "太阳",
                  updateBy: "",
                  isDel: false,
                  id: 160,
                  parentId: 156,
                  name: "朋友圈",
                  abbrName: "",
                  icon: "",
                  url: "/userData/wechatMoments",
                  perms: "",
                  type: 1,
                  orderNum: 0,
                  isShow: true,
                  isSepaLine: false,
                  list: [
                    {
                      createTime: "2024-07-27 14:11:45",
                      updateTime: "2024-07-27 14:11:45",
                      creator: "太阳",
                      updateBy: "",
                      isDel: false,
                      id: 161,
                      parentId: 160,
                      name: "朋友圈发圈",
                      abbrName: "",
                      icon: "",
                      url: "/userData/wechatMoments/engineMoments",
                      perms: "",
                      type: 1,
                      orderNum: 0,
                      isShow: true,
                      isSepaLine: false,
                      isAdmin: 0
                    },
                    {
                      createTime: "2024-07-27 14:12:04",
                      updateTime: "2024-07-27 14:12:04",
                      creator: "太阳",
                      updateBy: "",
                      isDel: false,
                      id: 162,
                      parentId: 160,
                      name: "朋友圈评论",
                      abbrName: "",
                      icon: "",
                      url: "/userData/wechatMoments/commentMoments",
                      perms: "",
                      type: 1,
                      orderNum: 0,
                      isShow: true,
                      isSepaLine: false,
                      isAdmin: 0
                    }
                  ],
                  isAdmin: 0
                },
                {
                  createTime: "2024-07-27 14:12:29",
                  updateTime: "2024-07-27 14:12:29",
                  creator: "太阳",
                  updateBy: "",
                  isDel: false,
                  id: 163,
                  parentId: 156,
                  name: "消息群发",
                  abbrName: "",
                  icon: "",
                  url: "/userData/groupMsg",
                  perms: "",
                  type: 1,
                  orderNum: 0,
                  isShow: true,
                  isSepaLine: false,
                  isAdmin: 0
                }
              ],
              isAdmin: 0
            },
            {
              createTime: "2024-07-27 14:12:58",
              updateTime: "2024-07-27 14:12:58",
              creator: "太阳",
              updateBy: "",
              isDel: false,
              id: 164,
              parentId: 155,
              name: "CDP",
              abbrName: "",
              icon: "",
              url: "/cdp",
              perms: "",
              type: 1,
              orderNum: 0,
              isShow: true,
              isSepaLine: false,
              list: [
                {
                  createTime: "2024-07-27 14:13:19",
                  updateTime: "2024-07-27 14:13:19",
                  creator: "太阳",
                  updateBy: "",
                  isDel: false,
                  id: 165,
                  parentId: 164,
                  name: "会员中心",
                  abbrName: "",
                  icon: "",
                  url: "/cdp/userCenter/index",
                  perms: "",
                  type: 1,
                  orderNum: 0,
                  isShow: true,
                  isSepaLine: false,
                  isAdmin: 0
                }
              ],
              isAdmin: 0
            }
          ],
          isAdmin: 0
        },
        {
          createTime: "2024-07-27 14:14:29",
          updateTime: "2024-07-27 14:14:29",
          creator: "太阳",
          updateBy: "",
          isDel: false,
          id: 166,
          parentId: 0,
          name: "产品中台",
          abbrName: "产品",
          icon: "https://test-static.tfeimall.com/src/menu/menuIcon_bd2ade27-3574-4172-9a6f-af3e3acd55b0_1722060867072.png",
          url: "",
          perms: "",
          type: 1,
          orderNum: 0,
          isShow: true,
          isSepaLine: false,
          list: [
            {
              createTime: "2024-07-27 14:14:53",
              updateTime: "2024-07-27 14:14:53",
              creator: "太阳",
              updateBy: "",
              isDel: false,
              id: 167,
              parentId: 166,
              name: "产品研发",
              abbrName: "",
              icon: "",
              url: "/plm",
              perms: "",
              type: 1,
              orderNum: 0,
              isShow: true,
              isSepaLine: false,
              list: [
                {
                  createTime: "2024-07-27 14:15:11",
                  updateTime: "2024-07-27 14:15:11",
                  creator: "太阳",
                  updateBy: "",
                  isDel: false,
                  id: 168,
                  parentId: 167,
                  name: "要货计划单",
                  abbrName: "",
                  icon: "",
                  url: "/plm/list",
                  perms: "",
                  type: 1,
                  orderNum: 0,
                  isShow: true,
                  isSepaLine: false,
                  isAdmin: 0
                },
                {
                  createTime: "2024-07-27 14:15:32",
                  updateTime: "2024-07-27 14:15:32",
                  creator: "太阳",
                  updateBy: "",
                  isDel: false,
                  id: 169,
                  parentId: 167,
                  name: "渠道库存报表",
                  abbrName: "",
                  icon: "",
                  url: "/plm/inventoryledger",
                  perms: "",
                  type: 1,
                  orderNum: 0,
                  isShow: true,
                  isSepaLine: false,
                  isAdmin: 0
                }
              ],
              isAdmin: 0
            }
          ],
          isAdmin: 0
        }
      ]
    }
  },
  computed: {
    ...mapState("user", ["routes", "favoriteMenus", "userInfo"])
  },
  created() {
    this.outClick()
    // this.$bus.$on("sidebarItemClick", item => {
    //   // 处理点击事件
    //   console.log(item)
    // })
  },
  beforeDestroy() {
    // this.$bus.$off("sidebarItemClick")
  },
  methods: {
    // 拼接收藏菜单
    newFavoriteMenus() {
      const obj = {
        name: "收藏菜单",
        id: -999,
        abbrName: "收藏",
        icon: "http://tf-scrm-test.oss-cn-shenzhen.aliyuncs.com/src/menu/menuIcon_790ef295-0dff-4f32-8cfb-6c0c365e2bc6_1722236140410.png",
        list: this.favoriteMenus
      }
      return obj
    },
    // 点击非菜单区域，关闭二层菜单
    outClick() {
      document.addEventListener("click", e => {
        if (this.$refs.sidebar) {
          const self = this.$refs.sidebar.contains(e.target)
          if (!self) {
            // 重制nowSys,让二层菜单隐藏
            this.$store.commit("user/SET_NOWSYS", "")
          }
        }
      })
    }
  }
}
</script>
<style scoped>
.sidebar {
  background-color: #132547; /* 背景色 */
  width: 200px; /* 初始宽度 */
  color: #ffffff; /* 文字颜色 */
  transition: width 0.1s ease; /* 过渡效果 */
  position: fixed;
  height: 100vh;
  z-index: 99999999999;
}
.sidebar .menu-items {
  padding: 10px 0;
}
</style>
